module.exports = __webpack_public_path__ + "img/08.08ca2460.jpg";